import React from "react";

const ApplyLoan = () => {
  return (
    <div className="flex items-center justify-center h-50">
      <p className="text-2xl font-semibold">Coming soon</p>
    </div>
  );
};

export default ApplyLoan;
